export var getters = {
    getJobWizardTime: function (state) { return function () { return performance.now() - state.startTime; }; },
    attachedAttributes: function (state) { var _a, _b; return (_b = (_a = state.job) === null || _a === void 0 ? void 0 : _a.attributes) !== null && _b !== void 0 ? _b : []; },
};
